/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type MigrateToWeb3MutationVariables = Types.Exact<{ [key: string]: never }>;

export type MigrateToWeb3Mutation = {
	__typename?: "Mutation";
	migrateToWeb3: {
		__typename?: "MigrateToWeb3Response";
		code: number;
		amount?: { __typename?: "CurrencyAmount"; value: string } | null;
	};
};

export const MigrateToWeb3Document = gql`
	mutation migrateToWeb3 {
		migrateToWeb3 {
			code
			amount {
				value
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class MigrateToWeb3GQLService extends Apollo.Mutation<MigrateToWeb3Mutation, MigrateToWeb3MutationVariables> {
	document = MigrateToWeb3Document;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
